import { debugB3React } from "../../../shared/utils/debug.js";
import { create } from "zustand";
import { persist } from "zustand/middleware";
const debug = debugB3React("useUserQuery");
/**
 * Zustand store for managing user state
 * Persists user data to localStorage
 */
export const useUserStore = create()(persist(set => ({
    user: null,
    setUser: (newUser) => {
        const userToSave = newUser ?? null;
        set({ user: userToSave });
        debug("User updated", userToSave);
    },
    clearUser: () => {
        set({ user: null });
        debug("User cleared");
    },
}), {
    name: "b3-user",
    skipHydration: true,
    onRehydrateStorage: () => (_, error) => {
        if (error) {
            console.warn("Failed to rehydrate user store:", error);
        }
    },
}));
